import { z } from 'zod';

export const SocialFormatSlug = z.enum([
  'intimate_groups',
  'networking',
  'masterminds',
  'one_on_one',
  'events',
]);
export type SocialFormatSlug = z.infer<typeof SocialFormatSlug>;

const FreeTextList = z.array(z.string().trim().min(1).max(200)).max(20);
const SlugList = z.array(z.string().min(1).max(64)).max(20);

export const UpdateUserContextInput = z.object({
  developmentSphereSlugs: SlugList.optional(),
  interestSlugs: SlugList.optional(),
  socialFormat: z.array(SocialFormatSlug).max(10).optional(),
  preferredAreas: FreeTextList.optional(),
  availabilitySlots: FreeTextList.optional(),
  goals: FreeTextList.optional(),
  taboos: FreeTextList.optional(),
  friendCriteria: FreeTextList.optional(),
});
export type UpdateUserContextInput = z.infer<typeof UpdateUserContextInput>;

export const UserContextDto = z.object({
  developmentSphereSlugs: z.array(z.string()),
  interestSlugs: z.array(z.string()),
  socialFormat: z.array(SocialFormatSlug),
  preferredAreas: z.array(z.string()),
  availabilitySlots: z.array(z.string()),
  goals: z.array(z.string()),
  taboos: z.array(z.string()),
  friendCriteria: z.array(z.string()),
});
export type UserContextDto = z.infer<typeof UserContextDto>;

export const LifeSphereDto = z.object({
  slug: z.string(),
  name: z.string(),
  /** EN-перевод name; отсутствует, если ещё не переведено. */
  nameEn: z.string().optional(),
  emoji: z.string(),
  color: z.string(),
  sortOrder: z.number(),
});
export type LifeSphereDto = z.infer<typeof LifeSphereDto>;

export const PlayerStatusDto = z.object({
  level: z.number(),
  slug: z.string(),
  name: z.string(),
  nameEn: z.string().optional(),
  threshold: z.number(),
  description: z.string(),
  descriptionEn: z.string().optional(),
});
export type PlayerStatusDto = z.infer<typeof PlayerStatusDto>;
